<template>
  <div class="dropdown col flex-grow-0 mx-1">
    <button
      id="fontsizeselector"
      class="border dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style="height: 2rem"
    >
      Fontsize
    </button>
    <ul class="bg-body dropdown-menu" aria-labelledby="fontsizeselector">
      <li
        v-for="fontSize in fontSizes"
        :key="fontSize"
        style="cursor: pointer"
        class="px-2"
        @click="editor.chain().focus().setFontSize(fontSize).run()"
      >
        {{ fontSize }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    editor: { type: Object, default: () => {} },
    fontSizes: { type: Array, default: ['12pt', '16pt', '28pt'] },
  },
  emits: [],
  setup() {
    return {};
  },
};
</script>